var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// always log in dev, and allow setting a flag to log in prod
var showDebugLogs = process.env.NODE_ENV !== 'production' ||
    (typeof window !== 'undefined' && localStorage.getItem('DEBUG') === 'true') ||
    (typeof window === 'undefined' && process.env.DEBUG === 'true');
var doLog = function (level) {
    var messages = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        messages[_i - 1] = arguments[_i];
    }
    var consoleLevel = level === 'critical' ? 'error' : level;
    if (level !== 'debug' || showDebugLogs) {
        console[consoleLevel].apply(console, __spreadArray([], __read(messages), false));
    }
};
export var logger = {
    info: doLog.bind(null, 'info'),
    warn: doLog.bind(null, 'warn'),
    error: doLog.bind(null, 'error'),
    debug: doLog.bind(null, 'debug'),
    log: doLog.bind(null, 'log'),
    critical: doLog.bind(null, 'critical'),
};
//# sourceMappingURL=logger.js.map